/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Action_UnarchiveInputs */



/**
* | output |
* | --- |
* | "Restore to my list" |
*
* @param {Spaces_Action_UnarchiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_action_unarchive = /** @type {((inputs?: Spaces_Action_UnarchiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Action_UnarchiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In meine Liste zurückholen")
	return /** @type {LocalizedString} */ ("Restore to my list")
});